<script>
  import Spinner from 'root/components/atoms/Spinner.svelte';
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import { currentUser } from 'root/angular-injector-provider';
  import get from 'lodash/get';
  import PHOTO_NOT_AVAILABLE from 'images/hotel_placeholder.png';
  import SetSupplierContactComponent from './SetSupplierContactComponent.svelte';

  export let hide, cancel, bids;

  let user;

  $: singleBid = bids.length === 1;
  $: bid = bids[bids.length - 1];
  $: logo = getLogo(bid);
  $: supplierName = bid.supplier.company.name;
  $: rfpName = bid.rfp.specifications.name;

  loadUser();

  function loadUser() {
    currentUser()
      .get()
      .then(u => (user = u));
  }

  function getLogo({ supplier }) {
    const image = get(supplier, 'company.logo');
    return image ? `images/logos/${image}` : PHOTO_NOT_AVAILABLE;
  }

</script>

<style lang="stylus">
  .Heading img {
    height: 70px;
    border-bottom-right-radius: 10px;
    margin-right: 15px;
    border: 1px solid #fff;
    object-fit: contain;
    background: #fff;
    width: 110px;
  }

  .Heading {
    display: flex;
    align-items: center;
  }

  .Header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 10px;
    line-height: 1;
    color: #546e7a;
  }

  .HeaderTitle {
    font-weight: bold;
    font-size: 13px;
    color: #455a64;
  }
  .Dialog :global(div > div.Heading) {
    background: #ebeff2;
  }

  .Dialog :global(div > div.Heading button.asLarge) {
    background: transparent;
  }

  .Dialog :global(.Banner) {
    position: relative;
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    min-height: 20px;
  }

  .Dialog :global(.Banner > span) {
    font-size: 20px;
    color: #556f7b;
    margin-right: 10px;
  }

  .Dialog :global(.Banner):before {
    content: "";
    display: block;
    height: 100%;
    background: #07a79d;
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    border-radius: 0 5px 5px 0;
  }

  .onlyContacts {
    display: flex;
    padding: 10px;
  }
</style>

{#if !user}
  <Spinner />
{:else}
  <div class="Dialog">
    <ClosableModal close={() => cancel()} width="650px">
      <div slot="heading" class="Heading">
        {#if singleBid}
          <img src={logo} alt={supplierName} />
          <div class="Header">
            <div class="HeaderTitle">{supplierName}</div>
            <p>{rfpName}</p>
          </div>
        {:else}
          <div class="HeaderTitle onlyContacts">Hotel Sales Contact</div>
        {/if}
      </div>
      <div>
        <SetSupplierContactComponent {cancel} {bids} {hide} />
      </div>
    </ClosableModal>
  </div>
{/if}
